import { Profiler } from 'react';
import { LOCAL_WIDGET_ID, WidgetTokenProvider } from '@elfsight/lib-utils';
import { WidgetI18nProvider } from '@elfsight/widget-i18n';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  WidgetFontsLoader
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import DICTIONARY from '../../language/dictionary.json';
import { meta } from '../constants';
import { DataProvider, PreparedSourceProvider } from './data';
import { LayoutProvider } from './layout';
import { ErrorBoundary, Main } from './main';
import { PopupProvider } from './popup';
import { VideoAutoplayProvider } from './post';
import { TabsProvider } from './tabs';
import { useSocialFeedSettings } from './utils';

const handleProfileRender = () => {};

const { alias } = meta;

export function Widget() {
  const {
    editMode,
    renderThumbnailMode,
    widgetId = '1',
    widgetWidth,
    widgetToken,
    customJS,
    customCSS
  } = useSettings();
  const { font, language } = useSocialFeedSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    alias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <WidgetTokenProvider
      widgetId={widgetId || LOCAL_WIDGET_ID}
      widgetToken={widgetToken}
    >
      <Profiler id="widget" onRender={handleProfileRender}>
        <ErrorBoundary>
          <WidgetI18nProvider
            dictionary={DICTIONARY}
            language={language?.language || 'en'}
            override={language?.messages ?? {}}
          >
            <WidgetFontsLoader fonts={[font]} />

            <PreparedSourceProvider>
              <PortalNestProvider customCSSClassName={customCSSPrefixClassName}>
                <TabsProvider>
                  <DataProvider>
                    <VideoAutoplayProvider>
                      <LayoutProvider>
                        <PopupProvider>
                          <EmbedRoot
                            id={`eapps-${alias}-${widgetId}`}
                            data-app={`eapps-${alias}`}
                            customCSSClassName={customCSSPrefixClassName}
                            width={widgetWidth}
                            className="RootLayout__RootComponent-sc"
                          >
                            <Main />

                            <CustomCSS
                              customCSS={customCSS}
                              prefixClassName={customCSSPrefixClassName}
                            />
                          </EmbedRoot>
                        </PopupProvider>
                      </LayoutProvider>
                    </VideoAutoplayProvider>
                  </DataProvider>
                </TabsProvider>
              </PortalNestProvider>
            </PreparedSourceProvider>
          </WidgetI18nProvider>
        </ErrorBoundary>
      </Profiler>
    </WidgetTokenProvider>
  );
}
